import React from 'react';

interface TableWaitingViewProps {
  tableNumber: string;
}

const TableWaitingView: React.FC<TableWaitingViewProps> = ({ tableNumber }) => {
  return (
    <div className="table-waiting">
      <h2>No open order yet</h2>
      <p>Please order with the waiter.</p>
      <p className="table-waiting-number">Table {tableNumber}</p>
    </div>
  );
};

export default TableWaitingView;
